module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "tlu",
      "src": "images/medium_logo_tlu_black_web.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v("The Web’s Creepiest Newsletter"), _c('br'), _vm._v("Delivered to Your Inbox")]), _vm._v(" "), _c('p', {
    staticClass: "centertop"
  }, [_vm._v("Get chilling stories of")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("true crime, mystery, horror,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("and the paranormal,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("twice a week.")]), _vm._v(" "), _c('p', {
    staticClass: "centertop"
  }, [_c('a', {
    attrs: {
      "href": "http://www.the-line-up.com?utm_source=TLUGOAAAAJ&utm_campaign=9781504016537",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "tlu_signup",
      "src": "images/tlu_signup.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a85ce7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/tlu.vue
// module id = 60
// module chunks = 0